import { createTemplateDashboard } from 'components/reusable/template/list';
import { GenericPass } from '../../../../ui/data-display/Passes/genericPass';
import { useListGenericPassTemplatesQuery } from 'services/genericPasses';


export const GenericPassTemplateDashboard = createTemplateDashboard({
  TemplateRenderer: GenericPass,
  listTemplateHook: useListGenericPassTemplatesQuery,
  i18nNamespace: "pass"
})